<!-- 问题批注-更多弹框 -->
<template lang="pug">
div
  van-share-sheet(v-model="morePopupShow" :title="question.fileName" :options="moreList" @select="onSelect")
  //- 状态弹框
  statusPopup(ref="statusPopup" @callback="refresh")
</template>

<script>
import { mapState } from "vuex";
import { Dialog, Notify } from "vant";
import { windowOpen } from "@/CommonDP/utils/docPublic.js";
import questionService from "@/CommonDP/service/question-service";
import statusPopup from "@/CommonDP/pages/appView/issueH5/components/statusPopup.vue";

export default {
  components: { statusPopup },
  data() {
    return {
      morePopupShow: false,
      question: {}, // 当前问题
      moreList: [
        { name: "定位", id: "aim", icon: require("@/CommonDP/pages/appView/issueH5/image/location.png") },
        { name: "编辑", id: "edit", icon: require("@/CommonDP/pages/appView/issueH5/image/edit.png") },
        { name: "删除", id: "del", icon: require("@/CommonDP/pages/appView/issueH5/image/delete.png") },
        { name: "修改状态", id: "sta", icon: require("@/CommonDP/pages/appView/issueH5/image/changeStatus.png") }
      ]
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userId: (state) => state.user.userId
    })
  },
  mounted() {},
  methods: {
    // 打开事件
    open(question) {
      this.question = question || {};
      this.morePopupShow = true;
    },
    // 刷新列表数据
    refresh() {
      this.$emit("refresh");
      this.morePopupShow = false;
    },

    // 更多功能
    onSelect(option) {
      let { name } = option || {};
      switch (name) {
        case "定位":
          this.toAim();
          break;
        case "编辑":
          this.toIssueEdit();
          break;
        case "删除":
          this.delete();
          break;
        case "修改状态":
          this.openStatus();
          break;
      }
    },
    // 定位
    toAim() {
      return Notify({ type: "warning", message: "暂不支持定位功能" });
    },
    // 进入批注编辑
    toIssueEdit() {
      let { questionId } = this.question || {};
      const issueItem = { questionId, isEdit: true };
      windowOpen({ path: "/project-issue/issueContent", query: issueItem });
    },
    // 删除
    delete() {
      let { questionId, creatorId } = this.question || {};
      if (this.userId !== creatorId) {
        return Notify({ type: "warning", message: "仅问题创建人有删除问题的权限" });
      }
      Dialog.confirm({
        title: "提示",
        message: `您将删除该问题，是否确认？`,
        confirmButtonColor: "#4777e7"
      })
        .then(async () => {
          const ids = [questionId];
          await questionService.DrawingQuestionDelete(ids);
          Notify({ type: "success", message: "删除成功" });
          this.refresh();
        })
        .catch(() => {});
    },
    // 打开状态弹框
    openStatus() {
      this.$refs.statusPopup.open(this.question);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .van-share-sheet__options {
  padding: 16px 8px;
  .van-share-sheet__option {
    &:first-child {
      margin-left: auto;
    }
    &:last-child {
      margin-right: auto;
    }
  }
}
</style>
